import { render } from "./ItemDetailPage.vue?vue&type=template&id=03aa3bb6&scoped=true"
import script from "./ItemDetailPage.vue?vue&type=script&lang=js"
export * from "./ItemDetailPage.vue?vue&type=script&lang=js"

import "./ItemDetailPage.vue?vue&type=style&index=0&id=03aa3bb6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03aa3bb6"]])

export default __exports__